const APP_LANGUAGE_STORAGE_KEY =
  "fitmeup_app_language";

function normalizeLanguageCode(value) {
  return String(value || "")
    .trim()
    .toLowerCase();
}

function normalizeAppLanguage(value) {
  const language =
    normalizeLanguageCode(value);

  if (language === "ru") {
    return "ru";
  }

  if (language === "en") {
    return "en";
  }

  return "";
}

function getTelegramWebApp() {
  if (typeof window === "undefined") {
    return null;
  }

  return window.Telegram?.WebApp || null;
}

function getLanguageFromInitDataUnsafe() {
  try {
    const tg = getTelegramWebApp();

    return normalizeLanguageCode(
      tg?.initDataUnsafe?.user?.language_code
    );
  } catch {
    return "";
  }
}

function getLanguageFromInitData() {
  try {
    const tg = getTelegramWebApp();

    const rawInitData =
      String(tg?.initData || "").trim();

    if (!rawInitData) {
      return "";
    }

    const params =
      new URLSearchParams(rawInitData);

    const rawUser =
      params.get("user");

    if (!rawUser) {
      return "";
    }

    const user =
      JSON.parse(rawUser);

    return normalizeLanguageCode(
      user?.language_code
    );
  } catch {
    return "";
  }
}

export function getSavedAppLanguage() {
  try {
    if (typeof window === "undefined") {
      return "";
    }

    return normalizeAppLanguage(
      window.localStorage.getItem(
        APP_LANGUAGE_STORAGE_KEY
      )
    );
  } catch {
    return "";
  }
}

export function saveAppLanguage(language) {
  const nextLanguage =
    normalizeAppLanguage(language);

  if (!nextLanguage) {
    return "";
  }

  try {
    window.localStorage.setItem(
      APP_LANGUAGE_STORAGE_KEY,
      nextLanguage
    );
  } catch {}

  return nextLanguage;
}

export function detectAppLanguage() {
  const savedLanguage =
    getSavedAppLanguage();

  if (savedLanguage) {
    return savedLanguage;
  }

  const telegramLanguage =
    getLanguageFromInitDataUnsafe() ||
    getLanguageFromInitData();

  if (telegramLanguage) {
    return telegramLanguage.startsWith("ru")
      ? "ru"
      : "en";
  }

  if (typeof navigator !== "undefined") {
    const language = normalizeLanguageCode(
      navigator.languages?.[0] || navigator.language
    );

    return language.startsWith("ru") ? "ru" : "en";
  }

  return "en";
}

export function getLocaleForLanguage(
  language
) {
  return language === "ru"
    ? "ru-RU"
    : "en-GB";
}